class UtilsHelper {
  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  capitalizePhrase(phrase: string = '') {
    try {
      return phrase
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    } catch (error) {
      return '';
    }
  }

  capitalizeFirstLetterPhrase(phrase: string = '') {
    try {
      return phrase
        .split(' ')
        .map((word, index) => (index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word))
        .join(' ');
    } catch (error) {
      return '';
    }
  }

  removeSpecialCharacters(str = '') {
    // Define the regular expression pattern for special characters
    var pattern = /[^a-zA-Z0-9]/g;

    // Use the replace() method to remove special characters
    var result = str?.toString().replace(pattern, '');

    return result;
  }

  removeAlphabetsCharacters(str = '') {
    // Define the regular expression pattern for special characters
    var pattern = /[^0-9]/g;

    // Use the replace() method to remove special characters
    var result = str?.toString().replace(pattern, '');

    return result;
  }

  cleanAndFormatPrice(price: any): any {
    if (price === null || price === undefined) {
      return '';
    }

    let cleanedPrice: string;

    if (typeof price === 'string') {
      const match = price.match(/[0-9,.]/g);
      cleanedPrice = match ? match.join('') : '';
    } else if (typeof price === 'number' && !isNaN(price)) {
      cleanedPrice = price.toLocaleString('en-US'); // Convert number to a locale-formatted string
    } else {
      return '';
    }

    const parsedPrice = parseFloat(cleanedPrice.replace(/,/g, ''));
    return isNaN(parsedPrice) ? '' : parsedPrice;
  }

  async convertImageToBase64(imageUrl: string, allowProxyUrl: boolean = false): Promise<string | null> {
    try {
      const imageUrlSource = allowProxyUrl ? `https://api.allorigins.win/raw?url=${encodeURIComponent(imageUrl)}` : imageUrl;
      const response = await fetch(imageUrlSource);
      if (!response.ok) {
        console.log('Image could not be fetched');
      }
      const blob = await response.blob();
      const reader = new FileReader();
      return new Promise<string>((resolve, reject) => {
        reader.onloadend = () => {
          resolve(reader.result as string);
        };
        reader.onerror = () => {
          reject('Error reading image file.');
        };
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Error fetching image:', error);
      return null;
    }
  }

  async copyToClipboard(textToCopy, callback) {
    try {
      await navigator.clipboard.writeText(textToCopy);
      callback(true);
      return true;
    } catch (err) {
      callback(false);
      return false;
    }
  }

  getTrimObjectKeys(obj) {
    const trimmedObject = {};
    Object.keys(obj).forEach(key => {
      const trimmedKey = key.trim();
      trimmedObject[trimmedKey] = obj[key];
    });
    return trimmedObject;
  }

  isHTMLElement(str) {
    var a = document.createElement('div');
    a.innerHTML = str;
    for (var c = a.childNodes, i = c.length; i--; ) {
      if (c[i].nodeType == 1) return true;
    }
    return false;
  }

  getDateStringFormat(date: Date): string {
    var d = date.getDate();
    var m = date.getMonth() + 1;
    var y = date.getFullYear();
    return '' + y + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
  }

  SortAtoZ(x, y) {
    if (x.name?.toLowerCase() < y.name?.toLowerCase()) {
      return -1;
    }
    if (x.name?.toLowerCase() > y.name?.toLowerCase()) {
      return 1;
    }
    return 0;
  }
  SortZtoA(x, y) {
    if (x.name?.toLowerCase() > y.name?.toLowerCase()) {
      return -1;
    }
    if (x.name?.toLowerCase() < y.name?.toLowerCase()) {
      return 1;
    }
    return 0;
  }

  isEmail(email) {
    let regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex?.test(email);
  }
  maskEmail(email: string): string {
    if (!email || !email.includes('@')) return email;

    const [username, domain] = email.split('@');
    const maskedUsername = username.slice(0, 2) + '****';

    return `${maskedUsername}@${domain}`;
  }
}
export const Utils = new UtilsHelper();
